export default "__VITE_ASSET__CIi7r$vh__"